'use client';

import { usePathname } from 'next/navigation';
import { ErrorBoundary } from '@/components/error-boundary';

export function adminShellOwnsMain(pathname: string) {
  return pathname.startsWith('/admin') && !['/admin/auth', '/admin/select-tenant', '/admin/impersonate']
    .some(prefix => pathname.startsWith(prefix));
}

export function MainContent({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isAdmin = pathname.startsWith('/admin');
  // The authenticated admin shell owns its content landmark after navigation.
  // Standalone admin handoff/auth pages still use this outer landmark.
  const adminOwnsMain = adminShellOwnsMain(pathname);
  const Container = adminOwnsMain ? 'div' : 'main';
  const isAuth = pathname.startsWith('/auth');
  // The employer funnel (request access, and the /signup route that now
  // redirects into it) is standalone — no header padding, no footer gap.
  const isSignup = pathname.startsWith('/signup') || pathname.startsWith('/request-access');
  // Live interview room is a full-screen video UI — no header padding, no
  // footer breathing room. Matches the layout exclusions in <Header /> and
  // <FooterWrapper />. Does NOT match /interview/{id}/review — that should
  // keep the standard chrome.
  const isInterviewRoom = /^\/interview\/[^/]+$/.test(pathname);

  return (
    <Container
      id={adminOwnsMain ? undefined : 'main-content'}
      tabIndex={adminOwnsMain ? undefined : -1}
      className={
        isAdmin || isAuth || isSignup || isInterviewRoom
          ? 'min-h-screen'
          : 'pt-16 pb-[var(--mobile-nav-height)] md:pb-8 min-h-screen'
      }
    >
      <ErrorBoundary mainLandmark={adminOwnsMain}>{children}</ErrorBoundary>
    </Container>
  );
}
